var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import APIIN from '../../../utils/APIIN';
import { CREATE_ORDER_DATA_REQUEST, createOrderDataFailure, createOrderDataSuccess } from '../../actions';
const createOrderDetails = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            APIIN.post("/order/", data)
                .then((response) => {
                console.log("API Response", response);
                resolve(response);
            })
                .catch((error) => {
                console.log("API Error", error);
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* createOrderDataWorker(action) {
    try {
        const data = yield call(createOrderDetails, action);
        yield put(createOrderDataSuccess(data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.messages) {
            // If error response contains a message, dispatch it
            console.log("error", error.response.data.messages);
            yield put(createOrderDataFailure(error.response.data.messages));
        }
        else {
            // If not, dispatch a generic error message
            console.log("cominggg");
            yield put(createOrderDataFailure(error));
        }
    }
}
export function* watchCreateOrderData() {
    yield takeLatest(CREATE_ORDER_DATA_REQUEST, createOrderDataWorker);
}
